<template>
    <AdminLayout>
        <HeatMap />
    </AdminLayout>
</template>

<script setup>
import HeatMap from '@/components/gmaps/HeatMap.vue';
import AdminLayout from '@/layouts/AdminLayout.vue';



</script>